<template>
  <div class="check-quotation" uk-height-viewport>
    <Header />
    <div>
      <div class="uk-flex uk-flex-center">
        <div>
          <br />

          <div
            class="uk-margin uk-grid-large uk-width-expand uk-flex uk-flex-center"
            uk-spinner
            v-show="isLoading"
          ></div>

          <legend
            v-show="!isLoading"
            class="uk-legend uk-margin-bottom uk-text-left uk-text-bolder"
          >
            Récapitulatif - Votre devis numéro
            <i>{{ $route.params.quotationID }}</i>
          </legend>

          <div
            class="uk-card uk-card-default uk-height-large uk-width-auto uk-padding uk-border-rounded uk-animation-fade"
            v-show="!isLoading"
          >
            <div class="uk-margin uk-grid uk-grid-small">
              <legend class="uk-legend uk-text-bolder uk-text-left">
                {{ getGenderTitle() }} {{ quotation.firstName }}
                {{ quotation.lastName }}
              </legend>
              <label
                class="uk-form-label uk-align-left uk-text-meta"
                for="form-stacked-text"
              >
                {{ quotation.address.address }},
                {{ quotation.address.zipCode }} {{ quotation.address.city }}
                {{ quotation.address.country }}
              </label>
            </div>
            <div
              class="uk-grid uk-grid-small"
              v-for="(delivery, index) in quotation.deliveries"
              :key="index"
              uk-grid
            >
              <p class="uk-text-center">
                {{ delivery.title }} {{ getDeliveryDetails(delivery) }}
              </p>
            </div>
            <br />
            <div class="uk-align-center uk-position-bottom">
              <a v-on:click="getQuotationDoc()">Voir les détails du devis.</a>
              <router-link :to="{ path: `/payment/${quotation.quotationID}` }">
                <button
                  class="uk-button uk-align-center uk-button-primary uk-position-bottom uk-border-rounded uk-text-bold"
                >
                  RÉGLER {{ quotation.amount }}€
                </button>
              </router-link>
            </div>

            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import firebase from "firebase";

export default {
  name: "check-quotation",
  components: {
    Header,
  },

  mounted() {
    const self = this;

    self.isLoading = true;
    firebase
      .firestore()
      .collection("Quotations")
      .where("quotationID", "==", this.$route.params.quotationID)
      .get()
      .then((querySnapshot) => {
        self.isLoading = false;
        if (querySnapshot.docs.length != 1) {
          this.displayErrorMessage(
            "Aucun devis ne porte ce numéro d'identification."
          );
          return;
        }
        querySnapshot.forEach((doc) => {
          self.quotation = doc.data();
        });
      })
      .catch((error) => {
        console.log(error);
        this.displayErrorMessage(
          "Aucun devis ne porte ce numéro d'identification."
        );
      });
    self.isConnected = localStorage.currentUser != null;
  },

  data() {
    return {
      currentUser: {},
      quotation: { address: {}, amount: 0 },
      isLoading: false,
      isConnected: false,
    };
  },
  methods: {
    getDeliveryDetails: function (delivery) {
      return delivery.type == "custom" ? "" : "de " + delivery.surface + "m²";
    },

    getQuotationDoc: function () {
      const storage = firebase.storage().ref();
      storage
        .child("quotations/Devis-" + this.quotation.quotationID + ".pdf")
        .getDownloadURL()
        .then(function (url) {
          window.open(url, "_blank", "fullscreen=yes");
        })
        .catch(function (error) {
          console.log(error);
          // Handle any errors
        });
    },

    getGenderTitle: function () {
      return this.quotation.gender == "male" ? "Monsieur" : "Madame";
    },
  },
};
</script>

<style scoped>
.white-background {
  background-color: white;
}

a:hover {
  color: #2a93ac;
  text-decoration: none;
}
</style>